import { Input } from 'antd';

export default Input;
